/** Image Slider Section */

import Swiper, { Autoplay, EffectFade, Lazy, Pagination } from "swiper";

export default {
    init() {
        this.initImagesSlider();
        this.initImageClip();
    },
    initImagesSlider() {
        if (document.querySelector('.swiper-images')) {
            Array.from(document.querySelectorAll('.swiper-images'))
                .forEach(el => {
                    let numberOfSlides = Array.from(el.querySelectorAll('.swiper-slide')).length;

                    el.swiper = new Swiper(el, {
                        modules: [Autoplay, EffectFade, Lazy, Pagination],
                        enabled: numberOfSlides > 1,
                        autoplay: {
                            delay: 7000,
                            disableOnInteraction: false,
                        },
                        slidesPerView: 1,
                        loop: true,
                        speed: 400,
                        preloadImages: false,
                        lazy: {
                            checkInView: true,
                            loadPrevNext: true,
                        },
                        effect: 'fade',
                        fadeEffect: {
                            crossFade: true
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            type: 'bullets'
                        },
                        initialSlide: numberOfSlides > 1 ? 1 : 0,
                        on: {
                            afterInit: (swiper) => {
                                if (numberOfSlides > 1) {
                                    swiper.slidePrev();
                                }
                            }
                        }
                    });
                });
        }
    },
    /**
     * Clip images slider wrapper based on vertical position
     */
    initImageClip() {
        if (document.querySelector('.section--images-slider')) {
            this.updateClipPath();
            window.addEventListener('scroll', this.updateClipPath);
        }
    },
    updateClipPath(event) {
        const wrappers = Array.from(document.querySelectorAll('.section--images-slider .swiper-wrapper'));
        const vh = window.innerHeight;
        const vw = window.innerWidth;

        wrappers.forEach(wrapper => {

            // Check that the wrapper is within the viewport
            let inView = (
                wrapper.getBoundingClientRect().top < vh
                && wrapper.getBoundingClientRect().top > (wrapper.getBoundingClientRect().height * -1)
            );

            if (inView) {
                let cw = document.querySelector('.section--images-slider .container'), // container
                    pl = parseInt(window.getComputedStyle(cw).getPropertyValue('padding-left')),
                    pr = parseInt(window.getComputedStyle(cw).getPropertyValue('padding-right'));

                let rh = (vh - (wrapper.getBoundingClientRect().top * 2)) / vh; // vertical position

                cw = cw.getBoundingClientRect().width - pl - pr; // Calc container width - any padding

                let dif = (vw - cw) / 2 * rh; // space between edge of screen and container * relative position

                // x vals to position with container
                let lx = vw - ((vw - cw) / 2) - cw;
                let rx = vw - ((vw - cw) / 2);

                // Values to have upper / lower bounds
                let maxLx = Math.floor(lx / vw * 100);
                let minRx = Math.floor(rx / vw * 100);

                // x position calcs
                lx = Math.floor((lx - dif) / vw * 100);
                rx = Math.floor((rx + dif) / vw * 100);

                // Boundaries for clip-path
                lx = (lx > maxLx) ? maxLx : lx;
                lx = (lx < 0) ? 0 : lx;
                rx = (rx < minRx) ? minRx : rx;
                rx = (rx > 100) ? 100 : rx;

                wrapper.style.clipPath = `polygon(${lx}% 0px, ${rx}% 0px, ${rx}% 100%, ${lx}% 100%)`;
            }
        });
    }
}
